import {
  TOGGLE_MODAL,
  SET_MODAL_PROPS,
  SET_MODAL_CONTENT,
  UNSET_MODAL_CONTENT,
  SET_MODAL_SIZE,
  SET_MODAL_CLASS,
  SET_MODAL_CLOSE_ON_CLICK,
  SET_MODAL_SHOW_CLOSE,
  SET_MODAL_CLOSE_ON_PRESS_ESCAPE,
  SET_MODAL_BUTTON_LOADING,
  UPDATE_PREVIEW_PARAM,
} from './../../mutation-types';

export default {
  [TOGGLE_MODAL](state, status = null) {
    state.modalState = status !== null && status !== undefined ? status : !state.modalState;
  },

  [SET_MODAL_SIZE](state, size = '50%') {
    state.modalSize = size;
  },

  [SET_MODAL_CLASS](state, customClass = 'responsive-modal') {
    state.modalClass = customClass;
  },

  [SET_MODAL_CONTENT](state, content) {
    state.modalContent = content;
  },

  [SET_MODAL_CLOSE_ON_CLICK](state, value = true) {
    state.modalCloseOnClick = value;
  },

  [SET_MODAL_SHOW_CLOSE](state, value = true) {
    state.modalShowClose = value;
  },

  [SET_MODAL_CLOSE_ON_PRESS_ESCAPE](state, value = true) {
    state.modalCloseOnPressEscape = value;
  },

  [UNSET_MODAL_CONTENT](state) {
    state.modalContent = {};
    state.modalProps = {};
  },

  [SET_MODAL_PROPS](state, props) {
    state.modalProps = props;
  },

  [SET_MODAL_BUTTON_LOADING](state, value = false) {
    state.modalButtonLoading = value;
  },

  [UPDATE_PREVIEW_PARAM](state, value = false) {
    state.modalProps = { ...state.modalProps, ...value };
  },

};



// WEBPACK FOOTER //
// ./src/app/store/modules/modal/mutations.js